module.exports = __webpack_public_path__ + "static/ambasador_gallus2-6c8c010c68541c4b394395b783ce23b8.png";